export default {
    AST: 'AST',
    FACT_SET: 'FACTSET'
};
